import { useState } from "react";
import { Grid, Button, CircularProgress } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import axios from "../../customAxios.js";
import { dateToDatabase, checkDownloadStatus } from "../../utils/functions.js";
import useSocket from "../../hooks/useSocket.jsx";

const DownloadStatusHistory = ({
  user,
  startDate,
  endDate,
  statusFilter,
  deliveriesCount,
  setErrorOnRetrieveData,
  handleSnack,
}) => {
  const [downloadExcelState, setDownloadExcelState] = useState(null);

  const isLoading = ["started", "processing"].includes(
    downloadExcelState?.status
  );
  const isDisabled = isLoading || deliveriesCount === 0;

  useSocket({
    userId: user.id,
    userRole: user?.user_type?.[0] || "unknown_role",
    eventPrefix: "download_history",
    onMessage: (data) => {
      console.log(`RECEIVED NOTIFICATION: ${JSON.stringify(data)}`);
      setDownloadExcelState(data);
      if (handleSnack) handleSnack(true, checkDownloadStatus(data.status));
    },
  });

  const fetchExcel = async () => {
    setDownloadExcelState({ status: "started" });

    const payload = {
      start_date: dateToDatabase(startDate),
      end_date: dateToDatabase(endDate),
      delivery_status: statusFilter,
    };

    try {
      const response = await axios.post("deliveries/download_status_history/", payload);
      console.table(response);
      if (setErrorOnRetrieveData) setErrorOnRetrieveData();
    } catch (error) {
      console.error(`[EXCEPTION] ${error}`);
      if (setErrorOnRetrieveData)
        setErrorOnRetrieveData("Ocurrió un error al obtener el excel");
    }
  };

  return (
    <Grid item xs={12} md={2} xl={2}  sx={{mb: 1}}>

      <Button variant="outlined" onClick={fetchExcel} disabled={isDisabled}>
        {isLoading ? (
          <CircularProgress className="loading-btn" />
        ) : (
          <>
            <DownloadIcon fontSize="small" />
            {deliveriesCount ? "Descargar Historial" : "Sin deliveries"}
          </>
        )}
      </Button>
    </Grid>
  );
};

export default DownloadStatusHistory;
